/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import Order from '../../interfaces/forms/Order';
import Filter from '../../interfaces/forms/Filter';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import moment, { Moment } from 'moment';
import { DateHelperTs } from '../../helpers/DateHelperTs';
import { FilterHelper } from '../lib/search/FilterHelper';
import GridItem from '../../components/Grid/GridItem';
import GridContainer from '../../components/Grid/GridContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import I18n from '../../components/Translate/I18n';
import { Auth, tokenInfo } from '../../modules/auth/Auth';
import TableBody from '@material-ui/core/TableBody';
import { Input, InputAdornment, TableFooter } from '@material-ui/core';
import Pager from '../../components/Adescom/PagerRange';
import TableHeaderContentCell from '../../components/Table/TableHeaderContentCell';
import Datetime from 'react-datetime';
import { PlusOrdersCommonResponseCollectionInterface } from '../../interfaces/collections/PlusOrdersCommonResponseCollectionInterface';
import PlkListItem from './view/PlkListItem';
import { PlusOrdersCommonResponse } from '../../interfaces/platform/PlusOrdersCommonResponse';
import { PlatformResellerCollectionInterface } from '../../interfaces/collections/PlatformResellerCollectionInterface';
import { MvnoBlockListCollectionInterface } from '../../interfaces/collections/MvnoBlockListCollectionInterface';
import ApiDialog from './components/ApiDialog';
import { PlusOrdersCommonResponseView } from './components/PlusOrdersCommonResponseView';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { Magnify } from 'mdi-material-ui';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import { FilterManager } from '../../modules/filter/FilterManager';
import { FilterReducerFieldName, FilterReducers } from '../../modules/filter/FilterReducers';
import { FilterListReducerFieldName } from '../../modules/filter/FilterListReducers';
import FilterList from '../../components/Filter/FilterList';
import PaperedTable from '../../components/Table/PaperedTable';
import { ListPropsInterface } from '../../modules/lib/ListPropsInterface';
import OplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import OPL_STYLE from '../../assets/themes/OPL/OplStyle';
import { NotificationHelper } from '../../helpers/NotificationHelper';
import { PlkListToCsv } from './Csv/PlkListToCsv';

interface PlkListStateInterface {
    items: PlusOrdersCommonResponseCollectionInterface | null;
    platformResellerList: PlatformResellerCollectionInterface | null;
    mvnoBlockList: MvnoBlockListCollectionInterface | null;
    orders: Array<Order>;
    filters: Array<Filter>;
    viewDialog: boolean;
    viewContent: any | null;
    viewTitle: any | string | null;
    requestQuery: string | null;
    responseQuery: string | null;
    showClearFilterButton: boolean;
    searchSendWithFitler: boolean;
    activeRow: number;
}

export const operationType = [
    { name: 'BME', value: 'BME' },
    { name: 'Service', value: 'Service' },
    { name: 'Resource', value: 'Resource' },
    { name: 'Subscriber', value: 'Subscriber' },
    { name: 'GEN/GMLC/ApiRest', value: 'REST_API_CALL' },
    { name: 'eSIM', value: 'eSIM' },
] as Array<{ name: string; value: string }>;

class PlkList extends PureComponent<ListPropsInterface, PlkListStateInterface> {
    private loaderCall: ItemLoaders;
    private filterManage: FilterManager;

    constructor(props: ListPropsInterface, context: PlkListStateInterface) {
        super(props, context);

        this.state = {
            items: null,
            orders: [],
            filters: [],
            platformResellerList: null,
            mvnoBlockList: null,
            viewContent: null,
            viewDialog: false,
            viewTitle: null,
            requestQuery: null,
            responseQuery: null,
            showClearFilterButton: false,
            searchSendWithFitler: false,
            activeRow: 0,
        };
        this.loaderCall = new ItemLoaders(this.props.dispatch);
        this.filterManage = new FilterManager();
    }

    componentDidMount(): void {
        this.setDefaultFilter((): void => {
            this.firstLoad();
        });
        // if (Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_ADMIN) {
        this.loadPlatformResellers();
        // }
        this.loadMvnoBlockList();
    }

    componentDidUpdate(prevProps: Readonly<ListPropsInterface>, prevState: Readonly<PlkListStateInterface>, snapshot?: any): void {
        const { dispatch, headerFilterElementHasValue, headerFilterElementName } = this.props;
        if (headerFilterElementName) {
            if (headerFilterElementHasValue) {
                this.filterManage.manageElement(headerFilterElementName, headerFilterElementHasValue);
            } else {
                this.filterManage.manageElement(headerFilterElementName, false);
            }
            this.setState({ showClearFilterButton: this.filterManage.hasManageElement() });
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            });
        }
    }

    setActiveRow = (id: number): void => {
        const { activeRow } = this.state;
        if (activeRow === id) {
            id = 0;
        }
        this.setState({ activeRow: id });
    };

    clearFilter = (): void => {
        this.setDefaultFilter((): void => {
            const { dispatch } = this.props;
            const { searchSendWithFitler } = this.state;
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
                clearAll: true,
            });
            dispatch({
                type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
            });
            if (searchSendWithFitler) {
                this.firstLoad();
            }
        });
    };

    loadPlatformResellers = (): void => {
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_resellers')),
            'plus_orders_common_response_platform_resllers_list',
            [],
            [],
            (data: PlatformResellerCollectionInterface): void => {
                this.setState({ platformResellerList: data });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    loadMvnoBlockList = (): void => {
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_lists')),
            'plus_orders_common_response_block_list',
            [{ name: 'pagination', value: false }],
            [],
            (data: MvnoBlockListCollectionInterface): void => {
                this.setState({ mvnoBlockList: data });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    setDefaultFilter = (callback: () => void): void => {
        const currentPeriod = moment();
        this.setState(
            {
                showClearFilterButton: false,
                filters: [
                    { name: 'createdAt[after]', value: DateHelperTs.getMonthFirstDaySimple(currentPeriod, 'YYYY-MM-01') },
                    { name: 'createdAt[before]', value: DateHelperTs.addMonthsToDate(currentPeriod, 1).format('YYYY-MM-01') },
                ],
                orders: [{ value: 'desc', name: 'createdAt' }],
            },
            (): void => {
                if (callback) {
                    callback();
                }
            }
        );
    };

    paginationCallbackFunction = (uri: string): void => {
        this.props.showMainLoader(true);
        this.loaderCall.paginationCallWithCallback(
            uri,
            'mvno_operations_collection_callback',
            (data: PlusOrdersCommonResponseCollectionInterface): void => {
                this.setState({ items: data });
                this.props.showMainLoader(false);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    updatePeriod = (date: string, fieldName: string): void => {
        let moment1 = moment(date);
        let filterHelper = new FilterHelper(this.state, { rangeFlag: false });
        let filter = filterHelper.updateField(fieldName + '[after]', DateHelperTs.getMonthFirstDaySimple(moment1, 'YYYY-MM-01'));
        if (filter === null) {
            return;
        }
        this.setState({ filters: filter }, (): void => {
            filterHelper = new FilterHelper(this.state, { rangeFlag: false });
            filter = filterHelper.updateField(fieldName + '[before]', DateHelperTs.addMonthsToDate(moment1, 1).format('YYYY-MM-01'));
            if (filter) {
                this.updateFilterList(filter);
            }
        });
    };

    firstLoad = (): void => {
        const { filters, orders, showClearFilterButton } = this.state;
        const { dispatch } = this.props;
        this.props.showMainLoader(true);
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/orders_common_responses')),
            'mvno_operations_collection_callback',
            filters,
            orders,
            (data: PlusOrdersCommonResponseCollectionInterface): void => {
                this.setState({ items: data, searchSendWithFitler: showClearFilterButton });
                this.props.showMainLoader(false);
                dispatch({
                    type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
                    showRender: true,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    updateOrderList = (orders: Array<Order>): void => this.setState({ orders: orders }, this.firstLoad);
    updateFilterList = (filters: Array<Filter>): void => this.setState({ filters: filters });

    updateSearachApiRequest = (): void => {
        const { requestQuery } = this.state;
        let filterHelper = new FilterHelper(this.state, { rangeFlag: false });
        let filter: Array<Filter> | null = null;
        if (!requestQuery) {
            filter = filterHelper.updateField('requestQuery', '');
        } else {
            filter = filterHelper.updateField('requestQuery', requestQuery);
        }
        if (filter) {
            this.updateFilterList(filter);
        }
    };

    updateSearachApiResponse = (): void => {
        const { responseQuery } = this.state;
        let filter: Array<Filter> | null = null;
        let filterHelper = new FilterHelper(this.state, { rangeFlag: false });
        if (!responseQuery) {
            filter = filterHelper.updateField('responseQuery', '');
        } else {
            filter = filterHelper.updateField('responseQuery', responseQuery);
        }
        if (filter) {
            this.updateFilterList(filter);
        }
    };

    viewPlkMessage = (item: PlusOrdersCommonResponse): void => {
        this.setState({
            viewDialog: true,
            viewContent: <PlusOrdersCommonResponseView item={item} />,
            viewTitle: <I18n trans={'prov:api.api_plk_method_call'} valueObject={{ function_name: item.command }} />,
        });
    };

    hideDialog = (): void => this.setState({ viewDialog: false, viewContent: null });

    exportToCsv = (): void => {
        const { items, platformResellerList, mvnoBlockList } = this.state;
        const { dispatch, showMainLoader } = this.props;
        if (items && !items['hydra:totalItems']) {
            NotificationHelper.notifyError('general:common.no_data_to_export', dispatch);
            return;
        }
        if (platformResellerList && mvnoBlockList) {
            const toCsv = new PlkListToCsv(new ItemLoaders(dispatch), platformResellerList, mvnoBlockList);
            toCsv.exportToCsv(this.state.orders, this.state.filters, showMainLoader);
        }
    };

    render(): React.ReactNode {
        const { classes } = this.props;
        const {
            items,
            filters,
            orders,
            platformResellerList,
            mvnoBlockList,
            viewContent,
            viewDialog,
            viewTitle,
            showClearFilterButton,
            activeRow,
        } = this.state;
        if ((Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_ADMIN && !platformResellerList) || !mvnoBlockList) {
            return null;
        }
        const tableStickyHeader = { root: classes.tableStickyHeader };
        const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
        const tableStickyCommand = { root: classes.tableStickyCommand };

        return (
            <GridContainer>
                <GridItem xs={12} md={12} lg={12}>
                    <PaperedTable
                        beforeTableContent={
                            <GridContainer>
                                <GridItem xs={12} className={classes.beforeTableContent}>
                                    <CustomTextButtom
                                        callback={this.firstLoad}
                                        callbackParam={{}}
                                        color="primary"
                                        label="general:common.search"
                                        size="lg"
                                    />
                                    {showClearFilterButton && (
                                        <CustomTextButtom
                                            callback={this.clearFilter}
                                            callbackParam={{}}
                                            color="primary"
                                            label="general:common.clear"
                                            size="lg"
                                        />
                                    )}
                                    <CustomTextButtom
                                        callback={this.exportToCsv}
                                        callbackParam={{}}
                                        color="primary"
                                        label="general:common.export_to_csv"
                                        size="lg"
                                    />
                                </GridItem>
                                <GridItem xs={12}>
                                    <FilterList />
                                </GridItem>
                            </GridContainer>
                        }
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell classes={tableControlStickyHeader} colSpan={7}>
                                    <GridContainer spacing={1}>
                                        <GridItem xs={2} style={{ marginTop: 15 }} className={classes.beforeTableContent}>
                                            <I18n trans="prov:h.search_period" />
                                            <Datetime
                                                className={'top-table-date-picker'}
                                                locale="pl"
                                                {...this.props}
                                                viewMode="months"
                                                defaultValue={moment(DateHelperTs.getCurrentDateSimple('YYYY-MM-01'))}
                                                dateFormat="YYYY-MM"
                                                timeFormat={false}
                                                onChange={(moment: Moment | string): void => {
                                                    if (typeof moment !== 'string') {
                                                        this.updatePeriod(moment.format('YYYY-MM-01'), 'createdAt');
                                                    }
                                                }}
                                                inputProps={{
                                                    id: 'createdAt',
                                                    placeholder: 'YYYY-MM',
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={3} style={{ marginTop: 22 }} className={classes.beforeTableContent}>
                                            <FormControl fullWidth={true}>
                                                <InputLabel>
                                                    <I18n trans="prov:h.message_request" />
                                                </InputLabel>
                                                <Input
                                                    id="requestQuery"
                                                    onChange={(event): void => this.setState({ requestQuery: event.target.value })}
                                                    onClick={(): void => {}}
                                                    name="requestQuery"
                                                    endAdornment={
                                                        <InputAdornment
                                                            position="start"
                                                            onClick={this.updateSearachApiRequest}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <Magnify fontSize={'small'} />
                                                        </InputAdornment>
                                                    }
                                                />
                                            </FormControl>
                                        </GridItem>
                                        <GridItem xs={3} style={{ marginTop: 22 }} className={classes.beforeTableContent}>
                                            <FormControl fullWidth={true}>
                                                <InputLabel>
                                                    <I18n trans="prov:h.message_response" />
                                                </InputLabel>
                                                <Input
                                                    id="responseQuery"
                                                    onChange={(event): void => this.setState({ responseQuery: event.target.value })}
                                                    onClick={(): void => {}}
                                                    name="responseQuery"
                                                    endAdornment={
                                                        <InputAdornment
                                                            position="start"
                                                            onClick={this.updateSearachApiResponse}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <Magnify fontSize={'small'} />
                                                        </InputAdornment>
                                                    }
                                                />
                                            </FormControl>
                                        </GridItem>
                                    </GridContainer>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell classes={tableStickyCommand} padding="none" align="left">
                                    <TableHeaderContentCell textAlign="left" title="general:common.commands" onlyFilter={true} />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="prov:list.id"
                                        fieldName="id"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="number"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                {/*{Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_ADMIN && (*/}
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        title="prov:list.partner"
                                        textAlign="left"
                                        fieldName="platformResellerId"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerPlatformReseller"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                {/*)}*/}
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="prov:list.block_request_id"
                                        fieldName="mvnoBlockRequestId"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="number"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                        nullable={true}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="prov:list.block"
                                        fieldName="mvnoBlockListId"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerMvnoBlockList"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                        platformResellerList={platformResellerList?.['hydra:member']}
                                        nullable={true}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="prov:list.operation"
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                        fieldName="command"
                                        showSort={true}
                                        onlyFilter={true}
                                        searchFieldType="select"
                                        selectComponent="headerCheckBoxSimpleList"
                                        elementList={operationType}
                                        filters={filters}
                                        sort={orders}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="prov:list.msisdn"
                                        fieldName="msisdn"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="number"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="prov:list.imsi"
                                        fieldName="imsi"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="desc"
                                        searchFieldType="string"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="prov:list.request_date"
                                        fieldName="requestTime"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="asc"
                                        searchFieldType="date"
                                        dateFormat="RRRR-MM-DD HH:MM"
                                        dateFromTo={true}
                                        filters={filters}
                                        sort={orders}
                                        breakLine={true}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="prov:list.response_date"
                                        fieldName="responseTime"
                                        showSort={true}
                                        onlyFilter={true}
                                        defaultDirection="asc"
                                        searchFieldType="date"
                                        dateFormat="RRRR-MM-DD HH:MM"
                                        dateFromTo={true}
                                        filters={filters}
                                        sort={orders}
                                        breakLine={true}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                        nullable={true}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="prov:list.status"
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                        fieldName="errorStatus"
                                        showSort={true}
                                        searchFieldType="select"
                                        selectComponent="headerPlkStatus"
                                        filters={filters}
                                        sort={orders}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items &&
                                items['hydra:member'] &&
                                items['hydra:member'].map((item: PlusOrdersCommonResponse) => {
                                    let rowActiveColor = 'white';
                                    if (activeRow === item.id) {
                                        rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
                                    }
                                    return (
                                        <PlkListItem
                                            item={item}
                                            viewPlkMessage={this.viewPlkMessage}
                                            platformResellerList={platformResellerList?.['hydra:member']}
                                            mvnoBlockList={mvnoBlockList?.['hydra:member']}
                                            key={'plk_request_response_' + item.id}
                                            setActiveRow={this.setActiveRow}
                                            rowActiveColor={rowActiveColor}
                                        />
                                    );
                                })}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={10}>
                                    {items && items['hydra:view'] && <Pager callback={this.paginationCallbackFunction} views={items} />}
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </PaperedTable>
                </GridItem>
                <ApiDialog open={viewDialog} fullWidth={true} closeCallback={this.hideDialog} content={viewContent} title={viewTitle} />
            </GridContainer>
        );
    }
}

const stateToProps = (state: { filterReducer: FilterReducers }): object => {
    const { filterReducer } = state;
    if (filterReducer && filterReducer.headerFilterElementName) {
        return {
            headerFilterElementHasValue: filterReducer.headerFilterElementHasValue,
            headerFilterElementName: filterReducer.headerFilterElementName,
        };
    }
    return {};
};

export default compose<any, any>(connect(stateToProps), withStyles(OplAppStyle))(PlkList);
